import React, { memo, useMemo } from 'react'
import { ImSpinner4 as Spinner } from 'react-icons/im'

import * as styles from './loadingOverlay.module.scss'
import classNames from 'classnames'

const LoadingOverlay = ({
   positionAbsolute,
   size,
   noBackground,
}: LoadingOverlayProps) => {
   const className = classNames(styles.wrapper, {
      [styles.absolute]: positionAbsolute,
      [styles.noBackground]: noBackground,
      [styles.lowZIndex]: size === 'small',
   })

   const spinnerSize = useMemo(() => {
      switch (size) {
         case 'small':
            return 28
         case 'xs':
            return 16
         case 'xxs':
            return 10
         default:
            return 40
      }
   }, [size])

   return (
      <div className={className}>
         <Spinner className={styles.icon} size={spinnerSize} />
      </div>
   )
}

export default memo(LoadingOverlay)
